<div class="flex flex-col gap-5 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm transition-all">
  <div class="flex flex-col gap-3">
    <h3 class="text-primary text-sm font-bold" i18n="@@attr.step.editTitle">Edit Attribute Title</h3>
  </div>

  <hr class="border-gray-100" />

  <div class="flex flex-col gap-6">
    <div class="grid grid-cols-1 items-start gap-4 md:grid-cols-2">
      <div class="flex flex-col gap-1.5">
        <label class="text-sm font-bold text-gray-700" i18n="@@attr.field.titleEn">Attribute Title (English)</label>
        <input
          type="text"
          [(ngModel)]="newAttributeKeyEn"
          i18n-placeholder="@@attr.placeholder.titleEn"
          placeholder="Enter attribute title (English, optional)"
          class="focus-border-primary w-full rounded-xl border border-gray-200 bg-white p-3 text-sm text-gray-800 outline-none" />
      </div>

      <div class="flex flex-col gap-1.5">
        <label class="text-sm font-bold text-gray-700">
          <span i18n="@@attr.field.titleAr">Attribute Title (Arabic)</span>
          <span class="text-red-500">*</span>
        </label>
        <input
          type="text"
          [(ngModel)]="newAttributeKeyAr"
          (blur)="arTouched.set(true)"
          i18n-placeholder="@@attr.placeholder.titleAr"
          placeholder="Enter attribute title (Arabic)"
          class="focus-border-primary w-full rounded-xl border border-gray-200 bg-white p-3 text-sm text-gray-800 outline-none" />
        @if (arTouched() && !newAttributeKeyAr()?.trim()) {
          <span class="text-xs font-medium text-red-500" i18n="@@attr.validation.titleArRequired">
            Arabic attribute title is required
          </span>
        }
      </div>
    </div>

    <div class="flex flex-col gap-3">
      <label class="text-sm font-bold text-gray-700" i18n="@@attr.col.values">Values</label>
      <div class="flex min-h-[45px] flex-wrap items-center gap-2 rounded-xl border border-dashed border-gray-200 p-2">
        @for (val of tempValues(); track $index) {
          <span
            class="text-primary flex items-center gap-2 rounded-full border border-red-100 bg-red-50 px-3 py-1.5 text-[11px] font-bold">
            <span class="truncate">{{ val.titleEn }}</span>
            <div class="ms-1 flex shrink-0 items-center gap-1.5 border-s border-red-200 ps-1.5">
              <svg
                (click)="openEditModal($index)"
                class="cursor-pointer hover:text-black"
                width="11"
                height="11"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
              <svg
                (click)="removeValue($index, $event)"
                class="cursor-pointer hover:text-black"
                width="11"
                height="11"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </div>
          </span>
        }
        <button (click)="openAddModal()" class="hover-text-primary text-gray-300">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="16" />
            <line x1="8" y1="12" x2="16" y2="12" />
          </svg>
        </button>
      </div>
    </div>

    <div class="mt-4 flex justify-end gap-3">
      <button
        (click)="goBack()"
        class="rounded-xl border border-gray-200 px-6 py-2.5 text-sm font-bold text-gray-500 transition-all hover:bg-gray-50"
        i18n="@@product.button.cancel">
        Cancel
      </button>
      <button
        (click)="updateAttribute()"
        [disabled]="!newAttributeKeyAr()?.trim() || isSaving()"
        class="bg-primary hover-bg-primary-hover rounded-xl px-8 py-2.5 text-sm font-bold text-white shadow-md transition-all disabled:opacity-50"
        i18n="@@attr.button.saveChanges">
        Save Changes
      </button>
    </div>
  </div>
</div>

@if (isModalOpen()) {
  <app-add-new-value
    [editData]="editData()"
    (onAdd)="handleValueAdded($any($event))"
    (onClose)="isModalOpen.set(false)" />
}
